import src from "IMAGE";
export default { src, width: 1310, height: 1310, blurWidth: 0, blurHeight: 0};
